@if (items.length === 0) {
  <span class="text-subdued px-8 py-2 text-sm">
    No Projects found
  </span>
}

<div appSelectableList #appSelectableList="appSelectableList" [deselectOnReclick]="false">
  <app-sidebar-item
    class="rounded [&:not(.drag-over)]:hover:bg-hover"
    *nestedFor="
      let project of items;
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let itemExpanded = expanded;
      stateKey: treeStateKey;
    "
    [title]="project.title"
    [badge]="{ template: badgeTemplate, context: { flagged: project.flagged, pinned: project.pinned, snoozed: project.snoozed, followed: project.followed } }"
    iconSlot="none"
    [depth]="depth"
    [expandable]="expandable"
    [expanded]="itemExpanded.value"
    [active]="selectedItemsIds | includesBy : project?.id"
    (onExpand)="itemExpanded.next($event)"
    (appClick)="openItem(project)"
    (appDblClick)="handleDblClick(project)"
    [appProjectContextMenu]="project"
    (appProjectContextMenuOpenProject)="handleMenuOpen(project)"
    [appSelectable]="project.id"
    [appSelectablePosition]="index"
    [appSelectableIdentifier]="project.id"
    [appSelectableListRef]="appSelectableList"

    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate(project)"
    (appDroppableDrop)="dndDrop($event, project)"

    appDraggable
    [appDraggableData]="items | selectedItemsDragData: selectedItemsIds: project"
    [appDraggablePlaceholder]="placeholder"
    [appDraggablePlaceholderContext]="{ item: project }"
    />
  </div>

  <ng-template #badgeTemplate let-flagged=flagged let-pinned=pinned let-snoozed=snoozed let-followed=followed>
    <div class="badge-template h-full flex flex-col justify-center items-center">
      @if (pinned) {
        <app-icon
          class="text-primary"
          size="xs"
          name="sapphire-pin-filled"
        />
      }
      @if (flagged) {
        <app-icon
          class="text-orange-500"
          name="sapphire-flagged-filled"
          size="xs"
        />
      }
      @if (snoozed) {
        <app-icon
          class="text-orange-500"
          name="sapphire-snooze"
          size="xs"
        />
      }
      @if (followed) {
        <app-icon
          class="text-primary"
          name="sapphire-follow-up"
          size="xs"
        />
      }
    </div>
  </ng-template>
